
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { createContext, useContext, useState, ReactNode } from "react";
import { Role } from "../types";

interface DemoContextProps {
  isDemoMode: boolean;
  activeRole: Role;
  toggleDemoMode: () => void;
  switchRole: (role: Role) => void;
}

const DemoContext = createContext<DemoContextProps>({} as DemoContextProps);

export const DemoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [activeRole, setActiveRole] = useState<Role>('merchant');

  const toggleDemoMode = () => setIsDemoMode(!isDemoMode);
  const switchRole = (role: Role) => setActiveRole(role);

  return (
    <DemoContext.Provider value={{ isDemoMode, activeRole, toggleDemoMode, switchRole }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => useContext(DemoContext);
